import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68cddf41"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "booking-checkout" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BookingHeader = _resolveComponent("BookingHeader")!
  const _component_Details = _resolveComponent("Details")!
  const _component_Newsletter = _resolveComponent("Newsletter")!
  const _component_Insurance = _resolveComponent("Insurance")!
  const _component_Charity = _resolveComponent("Charity")!
  const _component_Terms = _resolveComponent("Terms")!
  const _component_AgentCheckout = _resolveComponent("AgentCheckout")!
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (!_ctx.loading && !_ctx.isAgent)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_BookingHeader, {
                title: _ctx.$t('checkout.title'),
                subtitle: _ctx.$t('checkout.subtitle')
              }, null, 8, ["title", "subtitle"]),
              (_ctx.showAdditionalDetails)
                ? (_openBlock(), _createBlock(_component_Details, { key: 0 }))
                : _createCommentVNode("", true),
              (!_ctx.isAmendment)
                ? (_openBlock(), _createBlock(_component_Newsletter, { key: 1 }))
                : _createCommentVNode("", true),
              (_ctx.insurances.length > 0)
                ? (_openBlock(), _createBlock(_component_Insurance, {
                    key: 2,
                    insurances: _ctx.insurances
                  }, null, 8, ["insurances"]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.charityConfig.charities, (charity, index) => {
                return (_openBlock(), _createBlock(_component_Charity, {
                  key: index,
                  charity: charity
                }, null, 8, ["charity"]))
              }), 128)),
              _createVNode(_component_Terms)
            ]))
          : (!_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_AgentCheckout)
              ]))
            : (_openBlock(), _createBlock(_component_BaseSpinner, {
                key: 2,
                size: 50
              }))
      ]),
      _: 1
    })
  ]))
}